export default __webpack_public_path__ + "static/media/summary-stats-pending.1ac760aa.svg";